import React, { useEffect, useContext } from 'react'
import { Spacing } from '@opallabs/gem'
import { Popover } from '@opallabs/lapidary'
import {
  useSystemServiceOptions,
  ServiceOption,
} from '../../../../queries/useSystemServices'
import { WeekViewGlobalContext } from '../../../../weekViewGlobalContext'
import { AddContentButton, BUTTON_CLASS } from './AddContentButton'
import { CreateContentList } from './CreateContentList'

type AddContentPopoverProps = {
  buttonIsOutlined?: boolean
  collapseButton?: boolean
  disableButton?: boolean
  onCreateContent: (selected: Array<ServiceOption>, byKeypress: boolean) => void
  onClosePopover?: (byKeypress?: boolean) => void
  onBlurButton?: () => void
  onFocusButton?: () => void
  onOpenPopover?: () => void
}

const MIN_BUTTON_WIDTH_TEXT_DISPLAY = 100

export const AddContentPopover: React.FC<AddContentPopoverProps> = ({
  buttonIsOutlined = true,
  collapseButton = false,
  disableButton = false,
  onCreateContent,
  onClosePopover,
  onBlurButton,
  onFocusButton,
  onOpenPopover,
}) => {
  const [isVisible, setIsVisible] = React.useState(false)
  const [hideButtonText, setHideButtonText] = React.useState(false)
  const { currentBrandId } = useContext(WeekViewGlobalContext)
  const services = useSystemServiceOptions(currentBrandId.toString()).data || []

  const showPopover = () => {
    setIsVisible(true)
    onOpenPopover?.()
  }
  const hidePopover = (byKeypress?: boolean) => {
    setIsVisible(false)
    onClosePopover?.(byKeypress)
  }

  const createContent = (
    selected: Array<ServiceOption>,
    byKeypress: boolean
  ) => {
    hidePopover()
    onCreateContent(selected, byKeypress)
  }

  useEffect(() => {
    const buttonWidth = document.querySelector(`.${BUTTON_CLASS}`)?.clientWidth
    if (buttonWidth && buttonWidth < MIN_BUTTON_WIDTH_TEXT_DISPLAY) {
      setHideButtonText(true)
    } else {
      setHideButtonText(false)
    }
  }, [setHideButtonText])

  return (
    <Popover.Root open={isVisible} onOpenChange={setIsVisible}>
      <Popover.Trigger>
        <AddContentButton
          isOutlined={buttonIsOutlined}
          collapsed={collapseButton}
          disabled={disableButton}
          hideButtonText={hideButtonText}
          onClickAdd={() => (isVisible ? hidePopover() : showPopover())}
          onFocus={onFocusButton}
          onBlur={onBlurButton}
          popoverOpened={isVisible}
        />
      </Popover.Trigger>
      <Popover.Content
        style={{ zIndex: 9999 }}
        side="right"
        sideOffset={Spacing.S}
      >
        <CreateContentList
          focusSearch={isVisible}
          services={services}
          onCloseList={hidePopover}
          onCreateContent={createContent}
        />
      </Popover.Content>
    </Popover.Root>
  )
}
